// extracted by mini-css-extract-plugin
var _1 = "BestValueBadge_bestValueBtn__tm1dp";
export { _1 as "bestValueBtn" }
